import assetsApi from 'common/src/modules/Assets/Assets.api';
import {AssetFolderEntityType} from 'common/src/modules/Assets/Assets.enums';
import getAllAssetsFromTree from 'common/src/modules/Assets/utils/getAllAssetsFromTree';
import {assetDisplayConfigs} from 'common/src/modules/Assets/store/assetDisplayConfigs';
import {loadAssetTree} from 'common/src/modules/Assets/store/shared/thunks/loadAssetTree';
import {CLStore} from 'common/src/redux/store';
import {ColumnDataType, ContentFeed} from 'common/src/modules/contentFeeds/contentFeeds.types';

async function linkMissingAssetsToContentFeed(
  store: CLStore,
  feed: ContentFeed,
  items: {columnValues?: Record<string, string> | null}[],
) {
  const assetState = store.getState().contentFeedPage?.contentFeedAssets;
  const assetTree = assetState?.assetTree;

  if (!assetTree) return;

  const columns = feed.feedColumnsSchema?.columns ?? [];
  const imageVideoColumnKeys = new Set(
    columns
      .filter((c) => c.type === ColumnDataType.Image || c.type === ColumnDataType.Video)
      .map((c) => c.columnKey),
  );

  if (imageVideoColumnKeys.size === 0) return;

  const assetIds = new Set<number>();

  items.forEach((item) => {
    if (!item.columnValues) return;

    imageVideoColumnKeys.forEach((key) => {
      const value = item.columnValues?.[key];

      if (value !== null && value !== undefined) {
        const assetId = Number(value);

        if (!isNaN(assetId) && assetId > 0) {
          assetIds.add(assetId);
        }
      }
    });
  });

  if (assetIds.size === 0) return;

  const existingAssetIds = new Set(getAllAssetsFromTree(assetTree).map((a) => a.id));
  const missingAssetIds = Array.from(assetIds).filter((id) => !existingAssetIds.has(id));

  if (missingAssetIds.length === 0) return;

  const rootFolderId = assetTree.folderId;

  await Promise.all(
    missingAssetIds.map((assetId) =>
      assetsApi.linkAsset(assetId, {
        entityType: AssetFolderEntityType.ContentFeed,
        folderId: rootFolderId,
      }),
    ),
  );

  const config = assetDisplayConfigs[AssetFolderEntityType.ContentFeed];

  await store.dispatch(
    loadAssetTree({
      entityType: config.entityType,
      selectEntityId: config.selectEntityId,
      depth: config.loadAssetTreeDepth,
      setAssetTree: config.setAssetTree,
      setCurrentFolderId: config.setCurrentFolderId,
      setIsLoadingTree: config.setIsLoadingTree,
    }),
  ).unwrap();
}

export default linkMissingAssetsToContentFeed;
